import NaturezaOperacaoModel from "../models/naturezaOperacaoModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class NaturezaOperacaoService extends iServiceCached<NaturezaOperacaoModel> {
    constructor() {
        super("NaturezaOperacao");
    }

    public listByFranquiaId(franquiaId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/ListSaidaByFranquiaId?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        });
    }

    public getNaturezaByCliente(clienteId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetNaturezaByCliente?clienteId=${clienteId}`, {
            credentials: "same-origin",
        });
    }

    public getNaturezaByCodigo(codigo: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetNaturezaByCodigo?codigo=${codigo}`, {
            credentials: "same-origin",
        });
    }

    public getNaturezaEquivalenteById(naturezaOperacaoId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetNaturezaEquivalenteById?naturezaOperacaoId=${naturezaOperacaoId}`, {
            credentials: "same-origin",
        });
    }

    public getNaturezaDevolucaoByFornecedor(fornecedorId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetNaturezaDevolucaoByFornecedor?fornecedorId=${fornecedorId}`, {
            credentials: "same-origin",
        });
    }

    public async comboCached(franquiaId: number, forceRefresh = false) {
        const retorno = await this.combo(franquiaId, forceRefresh);

        return retorno
            .filter(p => p.ativo)
            .map(item => ({
                value: item.id!,
                text: `${item.codigo} - ${item.descricao}`,
                tipoMovimentacao: item.tipoMovimentacao,
                dentroEstado: item.dentroEstado,
                finalidadesEmissao: (item.finalidadesEmissao ?? []).map(p => p.finalidadeEmissao),
            }));
    }

    public async getNaturezaConsumidorFinalById(naturezaOperacaoId: number): Promise<Response> {
        return await nfetch(
            `/${this.controllerName}/GetNaturezaConsumidorFinalById?NaturezaOperacaoId=${naturezaOperacaoId}`,
            {
                credentials: "same-origin",
            },
        );
    }
}

export default new NaturezaOperacaoService();
